import { Text, VStack } from '@chakra-ui/react';
import React from 'react';

interface Props {
  title: string;
  children: React.ReactNode;
  disableScroll?: boolean;
}

const ContractVerificationMethod = ({ title, children, disableScroll }: Props) => {
  const ref = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    !disableScroll && ref.current?.scrollIntoView({ behavior: 'smooth' });
  }, [ disableScroll ]);

  return (
    <section ref={ ref }>
      <Text fontWeight={ 500 } fontSize="lg" fontFamily="heading" mt={{ base: 6, lg: 8 }} mb={ 6 }>{ title }</Text>
      <VStack align="stretch" spacing={{ base: 2, lg: 5 }}>
        { children }
      </VStack>
    </section>
  );
};

export default React.memo(ContractVerificationMethod);
